import uniqid from 'uniqid';

export default (prefix = 'id') => `${prefix}-${uniqid()}`;
